import OPut from 'oput';

const MSB = 0x80;
const REST = 0x7F;
const MSBALL = ~REST;
const INT = Math.pow(2, 31);
export function decode(data: OPut, obj: Object = null) {
  const tag = data.demand(1, true)[0];
  const type = tag & 0b111;
  const fieldNumber = tag >>> 3;
  switch (type) {
    case 0:
      let res = 0;
      let shift = 0;
      let b;
      do {
        if (data.buffer.length == 0 || shift > 49) {
          throw new RangeError('Could not decode varint');
        }
        b = data.demand(1, true)[0];
        res += shift < 28
          ? (b & REST) << shift
          : (b & REST) * Math.pow(2, shift);
        shift += 7;
      } while (b >= MSB);
      return res;
    case 2:
      if (obj == null) {
        const byteLen = decode(data) as number;
        const bufferLen = data.buffer.length;
        obj = {};
        while (byteLen > data.buffer.length - bufferLen) {
          decode(data, obj);
        }
        return obj;
      }
      const key = Object.keys(obj);
  }
}

function encodeVarint(value: number): Uint8Array {
  const oput = new OPut();
  while (value >= 0x80) {
    oput.malloc(1)[0] = (value & 0xFF) | MSB;
    value >>>= 7;
  }
  oput.malloc(1)[0] = value & 0xFF;
  return oput.buffer || new Uint8Array(0);
}

export function encode(obj: any, fieldNumber = 0): Uint8Array {
  const oput = new OPut();
  const tag = fieldNumber << 3;
  switch (typeof obj) {
    case 'boolean':
      const t = oput.malloc(2);
      t[0] = tag;
      t[1] = obj ? 1 : 0;
      break;
    case 'number':
      oput.malloc(1)[0] = tag;
      oput.write(encodeVarint(obj));
      break;
    case 'string':
      oput.malloc(1)[0] = tag | 2;
      const utf8Bytes = new TextEncoder().encode(obj);
      oput.write(encodeVarint(utf8Bytes.length));
      const buffer = oput.malloc(utf8Bytes.length);
      for (let i = 0; i < utf8Bytes.length; i++) {
        buffer[i] = utf8Bytes[i];
      }
      break;
    case 'object':
      const child = new OPut();
      if (Array.isArray(obj)) {
        for (let i = 0; i < obj.length; i++) {
          const childBytes = encode(obj[i], i + 1);
          if (childBytes) child.write(childBytes);
        }
      } else {
        let i = 1;
        for (const k in obj) {
          const childBytes = encode(obj[k], i++);
          if (childBytes) child.write(childBytes);
        }
      }
      if (fieldNumber === 0) {
        // 顶层对象，直接输出内容，不写入 tag 和 length
        if (child.buffer) {
          oput.write(child.buffer);
        }
      } else {
        // 嵌套对象，需要写入 tag 和 length
        oput.malloc(1)[0] = tag | 2;
        if (child.buffer) {
          oput.write(encodeVarint(child.buffer.length));
          oput.write(child.buffer);
        }
      }
  }
  return oput.buffer || new Uint8Array(0);
}
